<template>
  <v-container v-if="RBAC_system_VIEW_LOGS">
    <v-row justify="center">
      <v-col cols="12" class="text-center">
        <v-btn v-if="RBAC_system_DELETE_LOGS" class="mx-5" @click="clearLogs" color="error">{{ $t("delete_logs")
        }}</v-btn>
        <v-btn v-if="RBAC_system_DOWNLOAD_LOGS" class="mx-5" @click="downloadLogs" color="primary">{{ $t("download_logs")
        }}</v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col md="3" cols="6">
        <my-datepicker @input="loadTable" v-model="dateInz" :label="$t('date_inz')" required="true" />
      </v-col>
      <v-col md="3" cols="6">
        <my-datepicker @input="loadTable" v-model="dateEnd" :label="$t('date_end')" required="true" />
      </v-col>
      <v-col md="3" cols="6">
        <v-select v-model="selectedType" @change="loadTable" :items="listType" item-text="value" item-value="key"
          :menu-props="{ maxHeight: '400' }" :label="$t('esit')" required color="primary" persistent-hint></v-select>
      </v-col>
      <v-col md="3" cols="6">
        <v-select v-model="selectedMode" @change="loadTable" :items="listMode" item-text="value" item-value="key"
          :menu-props="{ maxHeight: '400' }" :label="$t('method')" required color="primary" persistent-hint></v-select>
      </v-col>
      <v-col cols="12">
        <DataTables :headers="headers" itemKey="logId" :expandFields="expandProp" :tableData="tableData"></DataTables>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

import Swal from "sweetalert2";
let _ = this;
export default {
  name: "view-logs",
  components: { MyDatepicker, DataTables },
  data() {
    return {
      dateInz: null,
      dateEnd: null,
      selectedType: null,
      listType: [
        { key: null, value: this.$t("all_m_p") },
        { key: "success", value: this.$t("success") },
        { key: "error", value: this.$t("error") },
      ],
      selectedMode: null,
      listMode: [
        { key: null, value: this.$t("all_m_p") },
        { key: "read", value: this.$t("read") },
        { key: "write", value: this.$t("write") },
        { key: "delete", value: this.$t("delete") },
      ],
      expandProp: ["params", "reqBody"],
      RBAC_system_VIEW_LOGS: false,
      RBAC_system_DELETE_LOGS: false,
      RBAC_system_DOWNLOAD_LOGS: false,
      headers: [
        { text: this.$t("date_time"), value: "datetime", type: "datetime" },
        { text: this.$t("duration_ms"), value: "durationMs", type: "numeric" },
        { text: this.$t("method"), value: "mode", type: "icons" },
        { text: this.$t("API_REST"), value: "url" },
        { text: this.$t("esit"), value: "esito", type: "icons" },
        { text: this.$t("http_status"), value: "http_status", type: "icons" },
        { text: this.$t("user"), value: "userName" },
      ],
      tableData: [],
    };
  },

  methods: {
    downloadLogs: function () {
      let link = this.authorizeLink(
        "/auth/portal/csv/downloadLogs?dateInz=" +
        this.dateInz +
        "&dateEnd=" +
        this.dateEnd
      );
      window.open(link);
    },
    clearLogs() {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios("DELETE", "/auth/portal/clearLogs").then(
            (response) => {
              if (response.msg.esito) {
                let html = "<strong>" + response.msg.msgTxt + "</strong>"
                Swal.fire({
                  type: "success",
                  html: html,
                });
                _.loadTable();
              }
            }
          );
        }
      });
    },
    loadTable() {
      let _ = this;
      _.tableData = [];
      _.isFetching = true;
      this.chiamataAxios("POST", "/auth/portal/listLogs", {
        body: {
          filter: {
            type: _.selectedType,
            mode: _.selectedMode,
            dateInz: _.dateInz,
            dateEnd: _.dateEnd,
          },
        },
      }).then((response) => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.map(function (item) {
          item.mode = [
            {
              label: item.method,
            },
          ];
          if (item.method === "GET") {
            item.mode[0].icon = "mdi-card-search-outline";
            item.mode[0].color = "primary";
          }
          if (item.method === "POST") {
            item.mode[0].icon = "mdi-card-search-outline";
            item.mode[0].color = "primary";
          }
          if (item.method === "PUT") {
            item.mode[0].icon = "mdi-content-save";
            item.mode[0].color = "success";
          }
          if (item.method === "DELETE") {
            item.mode[0].icon = "mdi-delete";
            item.mode[0].color = "error";
          }
          item.esito = [
            {
              label: item.msgTxt,
            },
          ];
          if (item.severity === 0) {
            item.esito[0].icon = "mdi-check-circle-outline";
            item.esito[0].color = "success";
          }
          if (item.severity === 1) {
            item.esito[0].icon = "mdi-alert-circle-outline";
            item.esito[0].color = "error";
          }
          if (item.severity > 1) {
            item.esito[0].icon = "mdi-minus-circle-outline";
            item.esito[0].color = "error";
          }
          item.http_status = [
            {
              label: item.status,
              icon:
                item.status === 200
                  ? "mdi-check-circle-outline"
                  : "mdi-close-circle-outline",
              color: item.status === 200 ? "success" : "error",
            },
          ];

          return item;
        });

        _.isFetching = false;
      });
    },
  },
  created() {
    this.dateEnd = new Date().toISOString().slice(0, 10);
    let dateInz = new Date();
    dateInz.setDate(dateInz.getDate() - 7);
    this.dateInz = dateInz.toISOString().slice(0, 10);
    this.loadTable();
    this.RBAC_system_VIEW_LOGS = this.checkUserRole("system", "VIEW_LOGS");
    this.RBAC_system_DELETE_LOGS = this.checkUserRole("system", "DELETE_LOGS");
    this.RBAC_system_DOWNLOAD_LOGS = this.checkUserRole(
      "system",
      "DOWNLOAD_LOGS"
    );
  },
};
</script>

